import type { FileLike, FileReference, MinimumUploadRequestResult } from 'stream-chat';

import { workchatGoImage } from '@/shared/api/workchat';

/**
 * Upload images using WC-Go endpoint instead of storing them onto Stream's CDN.
 * @param file
 * @returns
 */
export const customUploadConfig = async (file: FileLike | FileReference): Promise<MinimumUploadRequestResult> => {
  try {
    const formData = new FormData();
    formData.append('file', file as File);
    const { fullsize, thumbnail } = await workchatGoImage.url('/images').formData({ image: file }).post();
    return { file: fullsize, thumb_url: thumbnail };
  } catch (e: any) {
    let errorMessage = 'unknown error';

    if (e?.json?.errors) {
      const error = e.json.errors[0];

      switch (error.code) {
        case 'INVALID_FILE_TYPE': {
          errorMessage = 'unsupported file type';
          break;
        }
        case 'FILE_TOO_LARGE': {
          errorMessage = 'exceeding 10MB limit';
          break;
        }
      }
    }

    throw new Error(errorMessage);
  }
};
